<template>
  <div class="payOrder">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <p class="part_title">长按拖动设置扣款顺序，系统将根据以下排列顺序扣款</p>
    <draggable v-model="payRank" :options="options" @start="onStart" @end="onEnd">
      <transition-group>
        <div v-for="element in payRank" :key="element" class="drag-item">
          <van-cell :title="zh.zhCN.payTypes[element]">
            <template #right-icon>
              <svg-icon icon-class="drag" />
            </template>
          </van-cell>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import { accountInfo, accountEdit } from '@/api/user';
import draggable from 'vuedraggable';

export default {
  components: {
    draggable
  },
  data() {
    return {
      subHead: '支付顺序',
      drag: false,
      info: {},
      payRank: [],
      options: {
        delayOnTouchOnly: true, // 开启触摸延时
        direction: 'vertical', // 拖动方向
        delay: 500, // 延时时长
        touchStartThreshold: 3, // 防止某些手机过于敏感(3~5 效果最好)
        chosenClass: 'chosen' // 选中之后拖拽项添加的class名(用于选中时候添加样式)
      }
    };
  },
  created() {
    this.getAccountInfo();
  },
  methods: {
    getAccountInfo() {
      accountInfo({}).then(res => {
        if (res.code === 200) {
          this.info = res.data;
          this.payRank = res.data.payRank;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    // 开始拖拽事件
    onStart() {
      this.drag = true;
    },
    // 拖拽结束事件
    onEnd() {
      this.drag = false;
      this.info.payRank = this.payRank;
      accountEdit(this.info);
    }
  }
};
</script>

<style lang="less" scoped>
.payOrder {
  .part_title {
    color: #888;
    font-size: 0.14rem;
    margin-left: 0.15rem;
    line-height: 0.45rem;
  }
  .drag-item {
    .chosen{
      background-color: salmon;
    }
  }

}
</style>
